import TableChooseComponent from '../_COMPONENT/TableChooseComponent.jsx'
import {useTableColumnBdName, useTableColumnBdNo} from '../BD/useTableColumnBd.jsx'
import {useTableColumnRuleTitle} from '../BDLOGIC/useTableColumnBdlogic.jsx'

const TableChooseBdrule = (props) => {
    const columns = [
        useTableColumnBdName(),
        useTableColumnBdNo(),
        useTableColumnRuleTitle(),
    ]

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBdrule
